import { Ticket } from '@/redux/reducers/gameReducer'
import { PayloadBetCancel } from '@/redux/saga/fetchGameListSaga'
import { sagaActions } from '@/redux/sagaActions'
import { TicketStatus } from '@/ui-components/components/TicketStatusCard/TicketStatusBadge.types'
import dayjs from 'dayjs'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

export const useHandleCancel = () => {
  const dispatch = useDispatch()

  const onCancel = useCallback(
    (betId: number) => {
      const payload: PayloadBetCancel = { betId }
      dispatch({ type: sagaActions.POST_BET_CANCEL, payload })
    },
    [dispatch],
  )

  const checkCanCancel = useCallback((ticket?: Ticket) => {
    if (!ticket) return false
    const ticketCreationTime = dayjs(ticket?.created_at)
    const currentTime = dayjs()
    const duration = currentTime.diff(ticketCreationTime, 'minutes')
    const readyToCancel = [
      TicketStatus.WAITING,
      TicketStatus.APPROVED,
    ].includes(ticket.status as TicketStatus)
    const closed =
      ticket.lotto_round_game &&
      dayjs(ticket?.lotto_round_game?.close_at).isBefore(currentTime)
    return (
      duration <= 15 &&
      ticket?.lotto_round_game?.is_enable === 'yes' &&
      !closed &&
      readyToCancel
    )
  }, [])

  return { onCancel, checkCanCancel }
}
